import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ConfigLoginService extends ApiService {

  private loginType: string | null = null

  constructor(
    http: HttpClient,
    authService: NbAuthService) {
    super(http, authService);
  }

  loadConfig(): Observable<any> {
    const data = {
      tUrl: "https://prozesslaw.com/auth/login"
    };
    return this.http.post<any>('api/Account/PostInstanciaEjecucion', data);
  }

  setLoginType(type: string) {
    this.loginType = type;
  }

  getLoginType(): string | null {
    return this.loginType;
  }

}
